import { useQuery } from "react-query";
import { getEmployeesByEmployeeNumber } from "../../../../../actions/Employees/index";
export const useEmployeeNumber = (employeeNumber) => {
  return useQuery(
    ["GetEmployeesByEmployeeNumber", employeeNumber],
    () => getEmployeesByEmployeeNumber(employeeNumber),
    {
      enabled: !!employeeNumber,
      refetchOnWindowFocus: false,
    }
  );
};
